import { WizardStepBase } from "./wizard-step-base.model";

export class WizardFlow {
    steps: WizardStepBase[] = [];
    entryPath: string = "";
}
